import { render } from "./ContractsChart.vue?vue&type=template&id=f94902a6"
import script from "./ContractsChart.vue?vue&type=script&lang=js"
export * from "./ContractsChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__